import SidebarTranscripts from './SidebarTranscripts'

export default SidebarTranscripts
